(function () {
  'use strict';

  var root = document.querySelector('[data-rsp-root]');
  if (!root || root.dataset.rspReady === 'true') return;
  root.dataset.rspReady = 'true';

  var storyVersion = root.getAttribute('data-story-version') || 'product-description';
  var productId = root.getAttribute('data-product-id') || '';
  var cartStatus = root.querySelector('[data-rsp-cart-status]');

  function track(eventName, detail) {
    var payload = Object.assign(
      {
        event: eventName,
        story_version: storyVersion,
        product_id: productId
      },
      detail || {}
    );

    document.dispatchEvent(new CustomEvent('rarely:story-pdp', { detail: payload }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function announce(message) {
    if (cartStatus) cartStatus.textContent = message;
  }

  function observeStorySections() {
    if (!('IntersectionObserver' in window)) {
      track('story_pdp_viewed', { section_key: 'story' });
      return;
    }

    var seen = new Set();
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var sectionKey = entry.target.getAttribute('data-rsp-section') || 'story';
          if (seen.has(sectionKey)) return;
          seen.add(sectionKey);

          track(
            sectionKey === 'story' ? 'story_pdp_viewed' : 'story_section_viewed',
            { section_key: sectionKey }
          );
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.22, rootMargin: '0px 0px -10% 0px' }
    );

    document.querySelectorAll('[data-rsp-section]').forEach(function (section) {
      observer.observe(section);
    });
  }

  function bindStoryCtas() {
    document.querySelectorAll('[data-rsp-cta]').forEach(function (cta) {
      cta.addEventListener('click', function () {
        track('story_cta_clicked', {
          cta_location: cta.getAttribute('data-rsp-cta-location') || 'unknown'
        });
      });
    });
  }

  function bindStickyBuy() {
    var sticky = document.querySelector('[data-rsp-sticky]');
    var proxyButton = sticky && sticky.querySelector('[data-rsp-proxy-buy]');
    var stickyPrice = sticky && sticky.querySelector('[data-rsp-sticky-price]');
    var mainForm = document.getElementById('product-form');
    var mainButton = mainForm && mainForm.querySelector('[data-buy-btn]');
    var mainPrice = document.querySelector('.product-details .product-price');
    if (!sticky || !proxyButton || !mainButton) return;

    function syncStickyState() {
      var label = (mainButton.textContent || '').replace(/\s+/g, ' ').trim();
      proxyButton.textContent = label || 'Add to cart';
      proxyButton.disabled = mainButton.disabled;
      if (stickyPrice && mainPrice) {
        stickyPrice.textContent = mainPrice.textContent.trim();
      }
    }

    var queued = false;
    function updateStickyVisibility() {
      queued = false;
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var passedMainButton = mainButton.getBoundingClientRect().bottom < 0;
      var stickyHasFocus = sticky.contains(document.activeElement);
      var shouldShow = isMobile && (passedMainButton || stickyHasFocus);

      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      if (shouldShow) {
        proxyButton.removeAttribute('tabindex');
      } else {
        proxyButton.setAttribute('tabindex', '-1');
      }
      document.body.classList.toggle('rarely-story-sticky-visible', shouldShow);

      if (shouldShow) {
        document.documentElement.style.setProperty(
          '--rarely-story-sticky-height',
          sticky.offsetHeight + 'px'
        );
      }
    }

    function queueVisibilityUpdate() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(updateStickyVisibility);
    }

    proxyButton.addEventListener('click', function () {
      if (!mainButton.disabled) mainButton.click();
    });

    new MutationObserver(syncStickyState).observe(mainButton, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    if (mainPrice) {
      new MutationObserver(syncStickyState).observe(mainPrice, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
    window.addEventListener('resize', queueVisibilityUpdate, { passive: true });
    sticky.addEventListener('focusout', queueVisibilityUpdate);
    syncStickyState();
    updateStickyVisibility();
  }

  function openCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return true;
    }
    return false;
  }

  function refreshCartState() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart');
        return response.json();
      })
      .then(function (cart) {
        var badge = document.getElementById('cart-badge');
        if (badge) badge.textContent = cart.item_count;
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart } }));
        return cart;
      });
  }

  function bindComplementForms() {
    root.querySelectorAll('[data-rsp-complement-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var button = form.querySelector('[data-rsp-complement-add]');
        var variantInput = form.querySelector('input[name="id"]');
        var originalLabel = button ? button.textContent : 'Add';
        if (button) {
          button.disabled = true;
          button.textContent = 'Adding…';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().catch(function () { return {}; }).then(function (body) {
                throw new Error(body.description || 'This item could not be added.');
              });
            }
            return response.json();
          })
          .then(function (lineItem) {
            announce(lineItem.product_title + ' added to your cart.');
            if (button) button.textContent = 'Added';

            track('story_bundle_changed', {
              section_key: 'complements',
              variant_id: variantInput ? variantInput.value : '',
              bundle_units: 1,
              action: 'add'
            });

            return refreshCartState()
              .catch(function () {
                return null;
              })
              .then(function () {
                openCartDrawer();
              });
          })
          .catch(function (error) {
            announce(error.message || 'This item could not be added.');
            track('story_cart_error', {
              section_key: 'complements',
              variant_id: variantInput ? variantInput.value : '',
              message: error.message || 'unknown'
            });
            if (button) button.textContent = 'Try again';
          })
          .finally(function () {
            window.setTimeout(function () {
              if (!button) return;
              button.disabled = false;
              button.textContent = originalLabel;
            }, 1600);
          });
      });
    });
  }

  observeStorySections();
  bindStoryCtas();
  bindStickyBuy();
  bindComplementForms();
})();
